export const DEFAULT_SEPARATORS = ['Enter', 'Blur', 'Paste'];

export const ERRORS = {
  MaxValues: (limit: number) => `You can add maximum ${limit} keywords`,
};
